import { ResearchCategory } from '@snapi/types';
import { ResearchCategoryToBackgroundColor } from '@snapi/ui-utils';
import clsx from 'clsx';

interface ResearchCategoryBadgeProps {
  category: ResearchCategory;
}

export const ResearchCategoryBadge: React.FC<ResearchCategoryBadgeProps> = ({
  category,
}) => (
  <span
    className={clsx(
      category === ResearchCategory.disruptive ? 'text-white' : 'text-body',
      ResearchCategoryToBackgroundColor[category],
      'uppercase font-semibold text-xs px-3 py-1.5 rounded-full'
    )}
  >
    {category}
  </span>
);
